
/**
 * Returns the appropriate CSS classes for a task quadrant based on its background color
 * Enhanced with smooth micro-interactions and color transitions
 */
export function getQuadrantStyles(bgColor: string): string {
  switch (bgColor) {
    case "bg-red-50":
      return "border-2 border-priority-urgent-border bg-gradient-to-br from-priority-urgent-light to-priority-urgent-bg hover:shadow-colored-urgent hover:border-priority-urgent-hover hover:scale-[1.005] hover:-translate-y-0.5 transition-all duration-200 ease-in-out";
    case "bg-blue-50":
      return "border-2 border-priority-important-border bg-gradient-to-br from-priority-important-light to-priority-important-bg hover:shadow-colored-important hover:border-priority-important-hover hover:scale-[1.005] hover:-translate-y-0.5 transition-all duration-200 ease-in-out";
    case "bg-yellow-50":
      return "border-2 border-priority-delegate-border bg-gradient-to-br from-priority-delegate-light to-priority-delegate-bg hover:shadow-colored-delegate hover:border-priority-delegate-hover hover:scale-[1.005] hover:-translate-y-0.5 transition-all duration-200 ease-in-out";
    case "bg-gray-50":
      return "border-2 border-priority-later-border bg-gradient-to-br from-priority-later-light to-priority-later-bg hover:shadow-colored-later hover:border-priority-later-hover hover:scale-[1.005] hover:-translate-y-0.5 transition-all duration-200 ease-in-out";
    default:
      return "border-2 border-gray-200 bg-white hover:shadow-lg hover:border-gray-300 hover:scale-[1.005] hover:-translate-y-0.5 transition-all duration-200 ease-in-out";
  }
}
